<meta-title i18n>התחברות</meta-title>

<div class="auth-page">
  <header class="auth-page-header">
    <h2 i18n>התחברות</h2>
  </header>

  <div class="auth-card">
    <div class="auth-identity-chip" *ngIf="identityKey">
      <div class="auth-identity-chip__meta">
        <mat-icon aria-hidden="true">badge</mat-icon>
        <span class="muted" i18n
          >{identityMethod, select, idNumber {תעודת זהות} passport
          {דרכון}}:</span
        >
        <span class="value" dir="ltr">{{ identityKey }}</span>
      </div>
      <button type="button" (click)="reset()">
        <span i18n>שינוי</span>
        <mat-icon>arrow_back</mat-icon>
      </button>
    </div>

    <form
      [formGroup]="form"
      autocomplete="off"
      novalidate
      (submit)="verify()"
    >
      <div class="auth-field">
        <div class="auth-field__label-row">
          <label for="auth-password" i18n>סיסמה</label>
          <a
            routerLink="/reset-process/identify"
            [queryParams]="{ key: identityKey, method: identityMethod }"
            [skipLocationChange]="true"
            class="auth-inline-link"
            i18n
            >שכחתי סיסמה</a
          >
        </div>

        <div class="auth-input-wrap">
          <mat-icon class="auth-input-icon" aria-hidden="true">lock</mat-icon>
          <input
            id="auth-password"
            class="auth-input"
            [autofocus]="loadState"
            type="password"
            formControlName="password"
            autocomplete="current-password"
            required
            placeholder="••••••••"
          />
        </div>

        <p class="auth-hint" i18n>
          הסיסמה נשלחה אליך במייל בכניסה הראשונית למערכת
        </p>

        <div class="auth-field__feedback" aria-live="polite">
          <p class="auth-field-error" *ngIf="form | hasError: 'password'" i18n>
            סיסמה היא הכרחית
          </p>
        </div>
      </div>

      <div class="auth-form-actions auth-form-actions--row">
        <button type="button" class="auth-secondary-btn" (click)="reset()" i18n>
          ביטול
        </button>

        <ui-progress-button
          class="auth-submit"
          color="primary"
          [disabled]="form.invalid"
          [state]="verifyState"
          i18n
        >
          {verifyState.value, select, inProcess {מתחבר...} other {התחברות}}
        </ui-progress-button>
      </div>

      <div
        class="auth-alert"
        *visible="verifyState.error?.isVerificationFailed"
        i18n
      >
        הסיסמה שהזנת לא נכונה
      </div>

      <ui-error [state]="verifyState" [ignoreList]="[401]"> </ui-error>
    </form>
  </div>
</div>
